/**
 * Boxes as printed on ICS 217A-CG (Jan 2026), Communications Resource
 * Availability Worksheet.
 *
 * Boxes 1 to 3 are read-only on the card; 4 to 6 are editable, and 7 is the
 * signature recorded on the version bar.
 */
export const ICS217A_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  operationalPeriod: '3. Operational Period (Date/Time):',
  frequencyBand: '4. Frequency Band:',
  description: '5. Description:',
  channels: '6. Channel Configuration',
  preparedBy: '7. Prepared by:',
} as const;

/** Columns of box 6, in the order the sheet prints them. */
export const ICS217A_COLUMNS = [
  { key: 'channel_configuration', label: 'Channel Configuration' },
  { key: 'channel_name', label: 'Channel Name / Trunked Radio System Talkgroup' },
  { key: 'eligible_users', label: 'Eligible Users' },
  { key: 'rx_frequency', label: 'RX Freq N or W' },
  { key: 'rx_tone_nac', label: 'RX Tone/NAC' },
  { key: 'tx_frequency', label: 'TX Freq N or W' },
  { key: 'tx_tone_nac', label: 'TX Tone/NAC' },
  { key: 'mode', label: 'Mode (A, D, M)' },
  { key: 'remarks', label: 'Remarks' },
] as const;

/** Box 4 takes one of these; the instructions name them explicitly. */
export const ICS217A_FREQUENCY_BANDS = ['LF', 'MF', 'HF', 'VHF'] as const;

export const ICS217A_FREQUENCY_BAND_HINT =
  'Enter the frequency band in use (LF, MF, HF, or VHF).';

export const ICS217A_DESCRIPTION_HINT =
  'Enter a brief description of the communication resources being used.';
